require('trfShim');
require('./core/promise');
var bootstrap = require('./bootstrap/index');
var components = require('./components/index');

module.exports = {
    $: require('jquery'),
    //echarts: require('echarts'),
    url: require('./core/url'),
    //_: require('./core/lodash'),
    _: require('lodash-compat'),
    ajax: require('./core/ajax'),
    cacheFactory: require('./core/cache-factory'),
    Util: require('./core/util'),
    pathExtract: require('./core/path-extract'),
    Datetime: require('./core/datetime'),
    plugins: require('./plugins/index'),
    BootstrapDialog: bootstrap.BootstrapDialog,
    Router: components.Router,
    templateCache: components.templateCache,
    loading: components.loading,
    toast: components.toast,
    getDate: components.getDate,
    rowColSpan: components.rowColSpan,  // 2017-07-20
    uploadFile: components.uploadFile,  // 2018-09-18
    downloadFile: components.downloadFile,  // 2018-09-18
};


//////////////////
// WEBPACK FOOTER
// ./src/trf.js
// module id = 0
// module chunks = 0